import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import ListViewImagesSVG from '@client/assets/svgs/ListViewImages.svg';
import ListViewNamesSVG from '@client/assets/svgs/ListViewNames.svg';
import gsap from 'gsap';
import FilterStore from '@client/modules/ListModules/FilterStore';

const ListShowings = styled.div`
	margin-left: auto;
`;

const ImageListButton = styled.button`
	margin-right: 5px;
`;

const NameListButton = styled.button`
	margin-left: 5px;
`;

const ListViewImagesIcon = styled(ListViewImagesSVG)``;

const ListViewNamesIcon = styled(ListViewNamesSVG)``;

export default function FilteredListViewSelector() {
	const ImageListIcon = useRef<SVGSVGElement | null>(null);
	const NameListIcon = useRef<SVGSVGElement | null>(null);

	const view = FilterStore.use(state => state.view);

	useEffect(() => {
		updateListView(view === 'list' ? false : true);
	}, [view]);

	const updateListView = (value: boolean) => {
		if (!ImageListIcon.current || !NameListIcon.current) return;
		if (value === true) {
			gsap.to(ImageListIcon.current, {
				opacity: 1,
				duration: 0.3,
			});
			gsap.to(NameListIcon.current, {
				opacity: 0.1,
				duration: 0.3,
			});
		} else {
			gsap.to(ImageListIcon.current, {
				opacity: 0.1,
				duration: 0.3,
			});
			gsap.to(NameListIcon.current, {
				opacity: 1,
				duration: 0.3,
			});
		}
	};

	return (
		<ListShowings>
			<ImageListButton
				onClick={() => {
					FilterStore.setView('tile');
				}}
			>
				<ListViewImagesIcon ref={ImageListIcon} />
			</ImageListButton>
			<NameListButton
				onClick={() => {
					FilterStore.setView('list');
				}}
			>
				<ListViewNamesIcon ref={NameListIcon} />
			</NameListButton>
		</ListShowings>
	);
}
